import React, {useState} from "react";
import SmallLogo from "../assets/logo/small-logo.svg"

function Home() {
    const [isActive, setIsActive] = useState(false);

    const handleClickEducational = () => {
        setIsActive(false);
    };
    const handleClickAdvertising = () => {
        setIsActive(true);
    };

    return (
        <div className="home">
            <div className="home_header">
                <img src={SmallLogo} alt="logo" width={129} height={73}/>
                <div className="home_header__title">
                    Добро пожаловать в Cryptolottery777 !
                </div>
                <div className="home_header__content">
                    Прозрачность блокчейна, азарт игры и мгновенные выплаты. Здесь всё по-честному.
                </div>
            </div>

            <div className="profile_switch-btn-group">
                <div
                    className={isActive ? "profile_switch-btn-group__btn" : "profile_switch-btn-group__btn is-active-btn"}
                    onClick={handleClickEducational}>
                    <span
                        className={isActive ? "profile_switch-btn-group__btn___content" : "profile_switch-btn-group__btn___content is-active-btn"}>
                        Обучающий
                    </span>
                </div>
                <div
                    className={!isActive ? "profile_switch-btn-group__btn" : "profile_switch-btn-group__btn is-active-btn"}
                    onClick={handleClickAdvertising}>
                    <span
                        className={!isActive ? "profile_switch-btn-group__btn___content" : "profile_switch-btn-group__btn___content is-active-btn"}>
                        Cryptolottery777
                    </span>
                </div>
            </div>
            <div className="videos-group">
                <video key={isActive ? 1 : 2} controls height={225}>
                    <source
                        src={!isActive ? "https://cryptolottery777.com/public/video/1" : "https://cryptolottery777.com/public/video/2"}
                        type="video/mp4"
                    />
                    Ваш браузер не поддерживает HTML-видео.
                </video>
            </div>
        </div>
    )
}

export default Home